module.exports = "<div class=\"container\">\r\n  <div [ngStyle]=\"{'text-align': 'center'}\">\r\n    <h2>Servers console 1. </h2>\r\n  </div>\r\n  <app-servers></app-servers>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/server-console-1/servers-console/servers-console.component.html
// module id = ./src/app/components/server-console-1/servers-console/servers-console.component.html
// module chunks = main